// extracted by mini-css-extract-plugin
export default {"default":"OverlayInformationMessage_default__+-spM"};